import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import './ThirdSection.scss';
import SignUpIcon from '../../../assets/Images/Moniter icon.svg';
import DistributeIcon from '../../../assets/Images/check.svg';
import AnalyticsIcon from '../../../assets/Images/In-Depth Analytics.svg';
import CatalogIcon from '../../../assets/Images/Catalog Management.svg';
import SettlementIcon from '../../../assets/Images/Monthly Settlement.svg';
import SideImage from '../../../assets/Images/laptop home screen.png';
import Unlimitedmusicsign from '../../../assets/Images/white Unlimited music sign.svg';
import { Slide } from 'react-awesome-reveal';

function ThirdSection() {
    return (

        <Box className="third-section">
            <Container>
                <Slide direction="up" triggerOnce>
                    <Box className="content">
                        <Box className="third-section-heading">
                            <img src={Unlimitedmusicsign} alt="Unlimited Music Sign" className="icon-sign" />
                            <Typography variant="h4" component="h2" className="section-title">
                                Your Music, Globally. Keep Up to 95% of Your Earnings.
                            </Typography>
                        </Box>
                        <Box className="features">
                            <Box className="feature-item">
                                <img src={SignUpIcon} alt="Sign Up for Free" className="feature-icon" />
                                <Box className="feature-text">
                                    <Typography variant="h6">Sign Up for Free</Typography>
                                    <Typography variant="body2">Experience Our Easy-to-Use Platform.</Typography>
                                </Box>
                            </Box>
                            <Box className="feature-item">
                                <img src={DistributeIcon} alt="We Distribute Your Music Globally" className="feature-icon" />
                                <Box className="feature-text">
                                    <Typography variant="h6">We Distribute Your Music Globally</Typography>
                                    <Typography variant="body2">So You Can Focus on What Matters Most.</Typography>
                                </Box>
                            </Box>
                            <Box className="feature-item">
                                <img src={AnalyticsIcon} alt="In-Depth Analytics" className="feature-icon" />
                                <Box className="feature-text">
                                    <Typography variant="h6">In-Depth Analytics</Typography>
                                    <Typography variant="body2">Monitor Your Music's Performance.</Typography>
                                </Box>
                            </Box>

                            <Box className="feature-item">
                                <img src={CatalogIcon} alt="Catalog Management" className="feature-icon" />
                                <Box className="feature-text">
                                    <Typography variant="h6">Catalog Management</Typography>
                                    <Typography variant="body2">Organize All Your Music in One Central Location.</Typography>
                                </Box>
                            </Box>
                            <Box className="feature-item">
                                <img src={SettlementIcon} alt="Monthly Settlement" className="feature-icon" />
                                <Box className="feature-text">
                                    <Typography variant="h6">Monthly Settlement</Typography>
                                    <Typography variant="body2">Receive Regular Payments Every Month.</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Slide>
            </Container>
            <Box className="image-container">
                <img src={SideImage} alt="Side Image" className="side-image" />
            </Box>
        </Box>

    );
}

export default ThirdSection;

